class MessagingOpenConversationStore {
  private openCountsByChannelId = new Map<string, number>();

  open(channelId: string) {
    this.openCountsByChannelId.set(
      channelId,
      (this.openCountsByChannelId.get(channelId) ?? 0) + 1,
    );

    let isReleased = false;

    return () => {
      if (isReleased) return;
      isReleased = true;

      const remainingCount = (this.openCountsByChannelId.get(channelId) ?? 1) - 1;

      if (remainingCount > 0) {
        this.openCountsByChannelId.set(channelId, remainingCount);
      } else {
        this.openCountsByChannelId.delete(channelId);
      }
    };
  }

  isOpen(channelId: string) {
    return this.openCountsByChannelId.has(channelId);
  }
}

export default MessagingOpenConversationStore;
